import React, { useCallback, useEffect } from "react";
import Swal from "sweetalert2";
import { useAuth } from "hooks/useAuth";
import { printBookingPOS } from "../../utils/BookingPOSPrinter";

const PrintBookingExtra = ({ booking, refetch, onSuccess, onError }) => {
  const { user } = useAuth();

  const handlePrint = useCallback(() => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this booking?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        Swal.fire("Cancelled", "Printing cancelled", "info");
        return;
      }

      try {
        await printBookingPOS(booking, { type: "extra", user });
        Swal.fire({ title: "Printing", text: "Booking is being processed...", icon: "success", timer: 1500, showConfirmButton: false });
        onSuccess?.();
        refetch?.();
      } catch (error) {
        console.error("PrintJS Error:", error);
        Swal.fire("Error", "Failed to print booking", "error");
        onError?.();
      }
    });
  }, [booking, onError, onSuccess, refetch, user]);

  useEffect(() => {
    if (booking) handlePrint();
  }, [booking, handlePrint]);

  return <button className="btn btn-sm btn-success" onClick={handlePrint}>Print</button>;
};

export default PrintBookingExtra;
